import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { enableMapSet } from "immer";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
// DevTools removed — was showing debug panel to all users including production
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import App from "./App";
import "@/services/crisp.service";
import "@/services/cbb-support-bot";
import "./index.css";
import BotContextProvider from "@/pages/cbb-builder/store";
import { store } from "./neurodes-credentials/store";

enableMapSet();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  // <StrictMode>
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <BotContextProvider>
        <App />
      </BotContextProvider>
    </Provider>
    {/* ReactQueryDevtools removed — was visible to all users */}
  </QueryClientProvider>,
  // </StrictMode>,
);
